import React, { useMemo } from "react";
import { buildVimeoEmbedUrl } from "../../utils/vimeoPlayback";

/**
 * Vimeo iframe with startup quality and preloading controls applied before
 * the player requests its first video segment.
 */
export default function VimeoPlayer({
    video,
    id,
    className,
    style,
    responsive,
    width,
    height,
    title = "Vimeo video player",
    onLoaded,
    onError,
}) {
    const embedUrl = useMemo(() => buildVimeoEmbedUrl(video), [video]);
    if (!embedUrl) return null;

    const containerStyle = responsive
        ? {
            position: "relative",
            width: "100%",
            height: 0,
            paddingBottom: "56.25%",
            overflow: "hidden",
            ...style,
        }
        : { width, height, ...style };

    return <div id={id} className={className} style={containerStyle}>
        <iframe
            src={embedUrl}
            title={title}
            loading="eager"
            width="100%"
            height="100%"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            onLoad={onLoaded}
            onError={onError}
            style={responsive ? {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: 0,
            } : { border: 0 }}
        />
    </div>;
}
